import { _ } from '../../../lib';
const HISTORY_SECONDS = 0.35;
const LINE_WIDTH = 2;
const AMPLITUDE_SCALE = 0.9;
export const startWaveformAnimation = (input) => {
    const { canvas, analyser, shouldContinue } = input;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
        return () => { };
    }
    const bufferLength = analyser.fftSize;
    const dataArray = new Uint8Array(bufferLength);
    const historySize = Math.floor(analyser.context.sampleRate * HISTORY_SECONDS);
    const historyBuffer = new Float32Array(historySize).fill(0);
    const sliceCount = Math.min(bufferLength, historySize);
    const historyStart = historySize - sliceCount;
    let animationID = null;
    const draw = () => {
        if (!shouldContinue()) {
            animationID = null;
            return;
        }
        analyser.getByteTimeDomainData(dataArray);
        historyBuffer.copyWithin(0, bufferLength);
        const amplitudeSlice = _.chain(Array.from(dataArray.subarray(0, sliceCount)))
            .map(value => {
            const raw = (value ?? 128) / 128.0 - 1;
            const sign = raw >= 0 ? 1 : -1;
            return sign * Math.sqrt(Math.abs(raw)) * AMPLITUDE_SCALE;
        })
            .value();
        historyBuffer.set(amplitudeSlice, historyStart);
        const style = getComputedStyle(canvas);
        const bg = style.getPropertyValue('--waveform-bg') || '#f5f5f5';
        const stroke = style.getPropertyValue('--waveform-stroke') || '#333';
        ctx.fillStyle = bg;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.lineWidth = LINE_WIDTH;
        ctx.strokeStyle = stroke;
        ctx.beginPath();
        const sliceWidth = canvas.width / historySize;
        const points = _.chain(Array.from(historyBuffer))
            .map((value, index) => ({
            x: index * sliceWidth,
            y: (((value ?? 0) + 1) * canvas.height) / 2,
            index,
        }))
            .value();
        points.map(point => {
            if (point.index === 0) {
                ctx.moveTo(point.x, point.y);
                return point;
            }
            ctx.lineTo(point.x, point.y);
            return point;
        });
        ctx.lineTo(canvas.width, canvas.height / 2);
        ctx.stroke();
        animationID = requestAnimationFrame(draw);
    };
    draw();
    return () => {
        if (animationID !== null) {
            cancelAnimationFrame(animationID);
        }
    };
};
//# sourceMappingURL=waveform.js.map